interface RecursiveDictionary {
  [key: string]:
    | string
    | number
    | boolean
    | null
    | undefined
    | RecursiveDictionary
    | Array<string | number | boolean | null | undefined | RecursiveDictionary>;
}

export function removeEmpty(obj: RecursiveDictionary): RecursiveDictionary {
  const newObj: RecursiveDictionary = {};

  Object.keys(obj).forEach((key) => {
    if (obj[key] && typeof obj[key] === 'object' && !(obj[key] instanceof Array)) {
      newObj[key] = removeEmpty(obj[key] as RecursiveDictionary);
      if (Object.keys(newObj[key] as object).length === 0) {
        delete newObj[key];
      }
    } else if (Array.isArray(obj[key]) && (obj[key] as string[]).every((val) => !val)) {
      delete newObj[key];
    } else if (obj[key] !== null && obj[key] !== undefined && obj[key] !== '') {
      newObj[key] = obj[key];
    }
  });

  return newObj;
}
